"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  NEW_SHOT: 'new-shot',
  EXISTING_SHOT: 'existing-shot'
};
exports.default = _default;